import { render, staticRenderFns } from "./InboxCustomers.vue?vue&type=template&id=a6409f2a&"
import script from "./InboxCustomers.vue?vue&type=script&lang=js&"
export * from "./InboxCustomers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports